<template>
  <div class="first-stack need-padding" id="hero">
    <div class="left-Introduce">
      <div class="title-group">
        <span class="title">你好！</span>
        <span class="title">欢迎来到这里</span>
      </div>

      <div class="description">
        <span class="description-text">一个开发者构建的，<span class="inline-word">独属于自己的</span><br><span
            class="inline-word">“天空之城”</span></span>
      </div>
      <div class="first-stack-links">
        <router-link to="/about/site" class="about-button">
          <a>了解本站</a>
        </router-link>
        <a href="mailto:wangpeng.developer@outlook.com?subject=来自个人主页的留言&body=你好，我想和你沟通："
           class="about-button social-button" target="_blank" title="邮箱">
          <svg class="icon" viewBox="0 0 1024 1024" xmlns="http://www.w3.org/2000/svg"
              width="24" height="24">
            <path
                d="M512 589.44L36.096 180.48c2.56-0.576 4.864-1.664 7.488-1.664H980.48c1.6 0 4.992 1.152 7.552 1.6L512 589.44z m510.976-352.384v614.784c0 3.84-1.152 7.168-2.048 10.688l-337.92-348.544L1020.416 224c1.344 4.16 2.56 8.448 2.56 13.056zM3.584 223.936L341.12 513.984 3.2 862.528c-0.832-3.456-2.112-6.848-2.112-10.688V237.056c0-4.672 1.28-8.896 2.56-13.12z m646.528 328.896l340.736 351.36c-3.392 0.896-6.72 2.176-10.432 2.176H43.584c-3.584 0-6.912-1.28-10.24-2.176l340.672-351.36 124.352 106.88a20.672 20.672 0 0 0 27.264 0l124.48-106.88z"
                fill="var(--laputa-svg-inverse-color)"></path>
          </svg>
        </a>
        <a href="https://github.com/rocer-developer" class="about-button social-button" target="_blank" title="github">
          <svg t="1789977973260" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg"
               p-id="13619" width="24" height="24">
            <path
                d="M1023.560892 524.587752c0 114.331752-32.549236 217.148443-97.647709 308.450075-65.047295 91.301632-149.132822 154.455339-252.205404 189.512299-11.975662 2.303012-20.778286 0.716493-26.305515-4.759558a27.584966 27.584966 0 0 1-8.342021-20.471218V853.150798c0-44.166653-11.566238-76.511177-34.647536-96.982394a446.272549 446.272549 0 0 0 68.32269-12.282731c20.16415-5.476051 41.044792-14.329852 62.590748-26.612583a187.311643 187.311643 0 0 0 53.992837-45.446104c14.432209-18.014672 26.203159-41.914819 35.312851-71.751618 9.109692-29.8368 13.664538-64.074912 13.664538-102.765514 0-55.118754-17.554069-102.049021-52.61103-140.739623 16.376974-41.454216 14.636921-87.872703-5.373695-139.357815-12.436265-4.094244-30.399759-1.535341-53.941659 7.523172a355.17563 355.17563 0 0 0-61.311297 30.041513l-25.333132 16.376974a462.137743 462.137743 0 0 0-127.945112-17.707604 462.137743 462.137743 0 0 0-127.945111 17.758782 589.571074 589.571074 0 0 0-28.301459-18.424096c-11.77095-7.31846-30.34858-16.069906-55.681713-26.305515-25.281954-10.235609-44.422543-13.306292-57.31941-9.212048-19.498835 51.433935-21.085354 97.852421-4.606024 139.306637-35.108139 38.690602-52.713386 85.620869-52.713386 140.739623 0 38.690602 4.606024 72.826357 13.715716 102.458445 9.109692 29.58091 20.778286 53.481057 34.954605 71.700441a180.658498 180.658498 0 0 0 53.634591 45.753172c21.545957 12.282731 42.477777 21.18771 62.641926 26.612583 20.215328 5.527229 42.989557 9.621472 68.32269 12.333909-17.758781 16.376974-28.659705 39.867697-32.651593 70.369811a129.941055 129.941055 0 0 1-29.990334 10.235609 184.087426 184.087426 0 0 1-37.974109 3.428929c-14.688099 0-29.171485-4.913092-43.654872-14.688099-14.432209-9.826185-26.766117-24.053681-37.001726-42.682489a109.162769 109.162769 0 0 0-32.293346-35.517563c-13.101579-9.109692-24.104859-14.585743-33.009839-16.376974l-13.306292-2.047122c-9.314404 0-15.762838 1.023561-19.345301 3.070683-3.582463 2.047122-4.606024 4.606024-3.326572 7.83024a37.769397 37.769397 0 0 0 5.987831 9.570295 49.182101 49.182101 0 0 0 8.700267 8.188487l4.606024 3.377751c9.826185 4.606024 19.447657 13.255114 29.017952 25.998447 9.570294 12.743333 16.581686 24.360749 20.982998 34.80107l6.653146 15.71166c5.783119 17.298179 15.558126 31.320963 29.376197 42.017174 13.766894 10.747389 28.659705 17.554069 44.627255 20.471218 15.96755 2.968327 31.423319 4.606024 46.316131 4.810736 14.841633 0.204712 27.22672-0.562958 37.001726-2.405368l15.302235-2.712436c0 17.298179 0.102356 37.564685 0.358247 60.799517l0.307068 36.848192c0 8.188487-2.86597 15.046345-8.700268 20.471218-5.731941 5.527229-14.636921 7.113748-26.612583 4.810736-103.072582-35.056961-187.158109-98.261846-252.205404-189.512299C32.549236 741.736195 0 638.919504 0 524.587752c0-95.191163 22.876586-182.910331 68.629758-263.31104a516.028224 516.028224 0 0 1 186.288082-190.894106A491.309228 491.309228 0 0 1 511.780446 0.012795a491.309228 491.309228 0 0 1 256.913784 70.369811 516.028224 516.028224 0 0 1 186.236905 190.894106C1000.684306 341.626242 1023.560892 429.447767 1023.560892 524.587752z"
                fill="var(--laputa-svg-inverse-color)" p-id="13620"></path>
          </svg>
        </a>
        <a href="https://gitee.com/wangpeng_developer" class="about-button social-button" target="_blank" title="gitee">
          <svg t="1789963489520" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg"
               p-id="9785" width="24" height="24">
            <path
                d="M512 1024C229.222 1024 0 794.778 0 512S229.222 0 512 0s512 229.222 512 512-229.222 512-512 512z m259.149-568.883h-290.74a25.293 25.293 0 0 0-25.292 25.293l-0.026 63.206c0 13.952 11.315 25.293 25.267 25.293h177.024c13.978 0 25.293 11.315 25.293 25.267v12.646a75.853 75.853 0 0 1-75.853 75.853h-240.23a25.293 25.293 0 0 1-25.267-25.293V417.203a75.853 75.853 0 0 1 75.827-75.853h353.946a25.293 25.293 0 0 0 25.267-25.292l0.077-63.207a25.293 25.293 0 0 0-25.268-25.293H417.152a189.62 189.62 0 0 0-189.62 189.645V771.15c0 13.977 11.316 25.293 25.294 25.293h372.94a170.65 170.65 0 0 0 170.65-170.65V480.384a25.293 25.293 0 0 0-25.293-25.267z"
                fill="var(--laputa-svg-inverse-color)" p-id="9786"></path>
          </svg>
        </a>
      </div>
    </div>
    <div>
      <img class="hello-img" src="../../assets/hello.webp" alt="banner" title="banner">
    </div>
  </div>
  <div class="avatar-description glass">
    <span class="avatar-description-text">“构建此网站的初衷，一是为了帮助我学习前端，做一名全栈开发工程师；二是构建一个独属于我自己的个人网站。因此，作为初学者，网站的一些样式布局可能在专业人士看来并不是很完美，对于这些问题，欢迎指出。网站的内容我还在一点点摸索中，如果你有一些好的想法想告诉我，也欢迎你与我联系”</span>
    <img class="avatar-image" src="../../assets/avatar.webp" alt="头像走丢了"/>
    <span class="avatar-name">王朋</span>
    <span class="avatar-title">全栈开发工程师</span>
  </div>
</template>

<script setup>
</script>
<style scoped>
/* ========== PC端【完全保留原样，没有任何改动】 ========== */
.avatar-title {
  display: flex;
  margin: auto;
  font-size: var(--laputa-fontsize-14);
  opacity: 0.6;
  text-align: center;
}

span.avatar-name {
  display: flex;
  font-size: var(--laputa-fontsize-16);
  opacity: 1;
  margin: 14px auto auto;
}

.first-stack {
  display: flex;
  justify-content: space-between;
  margin-top: 150px;
  margin-bottom: 120px;
  align-items: center;
  max-width: 80%;
}

span.description-text {
  display: block;
  font-size: var(--laputa-fontsize-28);
  font-weight: 400;
  color: var(--laputa-common-font-color);
  line-height: 34px;
  margin-top: 28px;
}

a.about-button {
  display: flex;
  padding: 0 36px;
  background: var(--laputa-btn-background);
  color: var(--laputa-common-inverse-font-color);
  border-radius: 999px;
  box-shadow: var(--laputa-shadow-black);
  margin-top: 64px;
  width: fit-content;
  transition: ease-in-out 0.3s;
  white-space: nowrap;
  align-items: center;
  justify-content: center;
  height: 48px;
  font-size: var(--laputa-fontsize-15);
}

@keyframes floating {
  0% {
    transform: translateY(0px);
  }
  50% {
    transform: translateY(-8px);
  }
  100% {
    transform: translateY(0px);
  }
}

.first-stack-links {
  display: flex;
}

a.about-button:hover {
  background: var(--laputa-card-background-private-blue);
  box-shadow: var(--laputa-shadow-blue);
  color: var(--laputa-white);
}

.title-group {
  display: flex;
  flex-direction: column;
  font-size: var(--laputa-fontsize-70);
  color: var(--laputa-common-font-color);
  line-height: var(--laputa-fontsize-75);
  font-weight: bold;
}

.hello-img {
  width: 405px;
  max-width: 100%;
  pointer-events: none;
  object-fit: cover;
  transform: translate(-100px, 15px) scale(1.7);
}

.inline-word {
  word-break: keep-all;
  white-space: nowrap;
}

.avatar-description {
  display: flex;
  flex-direction: column;
  align-content: center;
  padding: 24px 32px;
  border-radius: 22px;
  line-height: 1.5;
  max-width: 80%;
  margin: 18px 5% 0;
}
.avatar-description:hover{
  box-shadow: var(--laputa-glass-shadow);
  border-color: var(--laputa-glass-border-color);
}

.avatar-description-text {
  display: flex;
  font-size: var(--laputa-fontsize-16);
  text-align: center;
  color: var(--laputa-common-font-color);
}

.avatar-image {
  cursor: pointer;
  width: 60px;
  height: 60px;
  border-radius: 50%;
  margin: 28px auto auto;
  border: 1px solid white;
  box-shadow: var(--laputa-shadow-lightblack);
  animation: floating 4s ease-in-out infinite;
}

.about-button.social-button {
  margin-left: 8px;
  padding: 0 16px;
  justify-content: center;
  transition: --laputa-svg-inverse-color 0.3s ease;
}
.social-button:hover{
  --laputa-svg-inverse-color:var(--laputa-white);
}

a {
  text-decoration: none;
  user-select: none;
  -webkit-user-drag: none;
}

span {
  user-select: none;
}

img {
  user-select: none;
  -webkit-user-drag: none;
}

@media screen and (max-width: 1200px) {
  img.hello-img {
    transform: translate(-60px, 55px) scale(1.5);
  }
}

@media (max-width: 768px) {
  .first-stack {
    margin-top: 60px;
    margin-bottom: 40px;
    flex-direction: column;
    align-items: flex-start;
    justify-content: flex-start;
    max-width: 100%;
    width: 94%;
  }
  .avatar-description {
    max-width: 100%;
    width: 94%;
  }
  .left-Introduce {
    width: 100%;
    text-align: left;
  }

  .title-group {
    line-height: 1;
    align-items: flex-start;
  }

  .title-group .title {
    font-size: 54px;
    line-height: 1;
    letter-spacing: -1px;
  }

  span.description-text {
    font-size: 22px;
    line-height: 1.4;
    margin-top: 24px;
    text-align: left;
  }

  .first-stack-links {
    display: flex;
    flex-wrap: nowrap;
    gap: 10px;
    align-items: center;
    margin-top: 36px;
  }

  a.about-button {
    margin-top: 0;
    height: 52px;
    padding: 0 28px;
  }

  a.about-button.social-button {
    width: 52px;
    height: 52px;
    padding: 0;
    margin-left: 0;
  }

  img.hello-img {
    display: none;
  }

  .avatar-description {
    padding: 20px;
    margin: 18px 3% 0;
  }
}

@media screen and (max-width: 375px) {
  .first-stack {
    margin-top: 40px;
    margin-bottom: 30px;
    width: 94%;
  }
  .title-group .title {
    font-size: 44px;
  }

  span.description-text {
    font-size: 20px;
    line-height: 1.4;
    margin-top: 20px;
  }

  .first-stack-links {
    gap: 8px;
    margin-top: 28px;
  }

  a.about-button {
    height: 46px;
    padding: 0 22px;
    font-size: 14px;
  }

  a.about-button.social-button {
    width: 46px;
    height: 46px;
  }
}

</style>
